import LegalShell, { LegalSection } from "../components/LegalShell";

export default function PrivacyPolicy() {
  return (
    <LegalShell
      title="Privacy Policy"
      subtitle="Effective September 1, 2026"
      description="How Mitaja Corporation collects, uses, and protects information submitted through this website."
      lastUpdated="September 1, 2026"
      documentLabel="Mitaja Corporation — Privacy Policy"
    >
      <LegalSection title="Information You Submit Through Our Forms">
        <p>
          Mitaja Corporation ("Mitaja," "we," "us," or "our") operates this website to provide information about our
          technology services for government and enterprise organizations. We collect information that you choose to submit
          through the contact inquiry form and the career resume form on this website, such as your name, email address,
          company or organization, the nature of your inquiry, and any message, resume, or other information you provide.
        </p>
        <p>
          Information submitted through the contact form is used to respond to your inquiry. Information submitted through
          the career form is used to evaluate your interest in opportunities at Mitaja and to contact you about relevant
          positions. We use this information only for the purpose for which you provided it, and for related administrative
          purposes.
        </p>
      </LegalSection>

      <LegalSection title="Purpose and Lawful Use of Information">
        <p>
          We collect and use the information described above to respond to inquiries, process submissions, evaluate
          candidates, and support our business and government-contracting activities. We process personal information
          submitted through this website on the basis of your consent (by submitting the form) and our legitimate interest
          in operating this website and responding to business and recruiting inquiries.
        </p>
        <p>
          We do not sell personal information submitted through this website. We share personal information only as needed to
          operate this website, comply with legal obligations, or protect the rights, property, or safety of Mitaja, our
          partners, or others.
        </p>
      </LegalSection>

      <LegalSection title="Technical Information We May Collect">
        <p>
          When you visit this website, our hosting and infrastructure providers may automatically collect basic technical
          information such as your internet protocol (IP) address, browser type and version, operating system, device type,
          approximate geographic location, pages visited, and the date and time of your visit. This information is used for
          the operation, security, and performance of the website and to understand general usage patterns.
        </p>
      </LegalSection>

      <LegalSection title="Cookies and Analytics">
        <p>
          This website does not currently use advertising or marketing cookies and does not currently rely on third-party
          analytics services that set tracking cookies on your device. Basic technical information described above may be
          processed by our hosting provider for security and performance purposes. If we add analytics or cookie-based
          features in the future, we will update this policy accordingly before doing so.
        </p>
      </LegalSection>

      <LegalSection title="Third-Party Services and Outbound Links">
        <p>
          This website contains links to external websites and services, including links to time-management and payroll
          providers for employee use. These third-party sites have their own privacy policies and terms, which we do not
          control. When you leave this website, the information practices of those sites apply. We are not responsible for
          the content or privacy practices of external websites.
        </p>
      </LegalSection>

      <LegalSection title="Data Retention and Security">
        <p>
          We retain information submitted through this website only for as long as reasonably necessary for the purpose for
          which it was provided, to respond to inquiries, to evaluate candidates, or as required by law, record-keeping, or
          business practices. We apply reasonable administrative, technical, and organizational measures designed to protect
          the information we collect. No method of transmission or storage is completely secure, and we cannot guarantee
          absolute security.
        </p>
      </LegalSection>

      <LegalSection title="Your Rights to Access, Correction, and Deletion">
        <p>
          You may request access to the personal information you have submitted through this website, request that we correct
          inaccurate information, or request that we delete your information. To make such a request, contact our
          government-sales team using the contact information below. We will respond to reasonable requests in accordance
          with applicable law.
        </p>
      </LegalSection>

      <LegalSection title="Government-Sales Privacy Contact">
        <p>
          For privacy-related requests, including requests for access, correction, or deletion, please contact:
        </p>
        <p className="font-semibold text-foreground-900">
          <a
            href="mailto:governmentsales@mitajacorp.com"
            className="text-primary-700 hover:text-primary-600 underline"
          >
            governmentsales@mitajacorp.com
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. When we do, we will revise the "Last updated" date at the top
          of this page.
        </p>
      </LegalSection>
    </LegalShell>
  );
}